export enum PARTNER_NAVIGATION {
  PARTNER_INFO = 'partner-info',
  ADDRESS = 'address',
  CONTACT = 'contact',
  SUPPORT = 'support',
  NOTIFICATIONS = 'notifications',
  BANK = 'bank',
  FEES = 'fees',
  WEBHOOKS = 'webhooks',
  CONFIGURATIONS = 'configurations',
  API_KEYS = 'api-keys',
}

export const partnerNavigationLinks = [
  {
    path: PARTNER_NAVIGATION.PARTNER_INFO,
    text: 'PARTNERS.PARTNER_INFO',
    additionalClass: 'd-flex',
  },
  {
    path: PARTNER_NAVIGATION.ADDRESS,
    text: 'PARTNERS.PARTNER_ADDRESS',
    additionalClass: 'd-flex',
  },
  {
    path: PARTNER_NAVIGATION.CONTACT,
    text: 'PARTNERS.PARTNER_CONTACT',
    additionalClass: 'd-flex',
  },
  {
    path: PARTNER_NAVIGATION.SUPPORT,
    text: 'PARTNERS.PARTNER_SUPPORT',
    additionalClass: 'tab-partner-customer-support',
  },
  {
    path: PARTNER_NAVIGATION.NOTIFICATIONS,
    text: 'PARTNERS.PARTNER_NOTIFICATIONS',
    additionalClass: 'tab-partner-notifications',
  },
  {
    path: PARTNER_NAVIGATION.BANK,
    text: 'PARTNERS.PARTNER_BANK',
    additionalClass: 'tab-partner-bank',
  },
  {
    path: PARTNER_NAVIGATION.FEES,
    text: 'PARTNERS.PARTNER_FEES',
    additionalClass: 'tab-partner-fees',
  },
  {
    path: PARTNER_NAVIGATION.WEBHOOKS,
    text: 'PARTNERS.PARTNER_WEBHOOKS',
    additionalClass: 'tab-partner-fees',
  },
  {
    path: PARTNER_NAVIGATION.API_KEYS,
    text: 'PARTNERS.PARTNER_API_KEYS',
    additionalClass: 'tab-partner-api-keys',
  }
];

export const additionalPartnerNavigationLinks = [
  {
    path: PARTNER_NAVIGATION.SUPPORT,
    text: 'PARTNERS.PARTNER_SUPPORT',
    additionalClass: 'tab-partner-customer-support-additional',
  },
  {
    path: PARTNER_NAVIGATION.NOTIFICATIONS,
    text: 'PARTNERS.PARTNER_NOTIFICATIONS',
    additionalClass: 'tab-partner-notifications-additional',
  },
  {
    path: PARTNER_NAVIGATION.BANK,
    text: 'PARTNERS.PARTNER_BANK',
    additionalClass: 'tab-partner-bank-additional',
  },
  {
    path: PARTNER_NAVIGATION.FEES,
    text: 'PARTNERS.PARTNER_FEES',
    additionalClass: 'tab-partner-fees-additional',
  },
  {
    path: PARTNER_NAVIGATION.WEBHOOKS,
    text: 'PARTNERS.PARTNER_WEBHOOKS',
    additionalClass: 'tab-partner-fees-additional',
  },
  {
    path: PARTNER_NAVIGATION.API_KEYS,
    text: 'PARTNERS.PARTNER_API_KEYS',
    additionalClass: 'tab-partner-api-keys-additional',
  }
];
